// // import React, { useState, useEffect, useRef } from "react";
// // import {
// //   ChevronLeft,
// //   ChevronRight,
// //   Calendar,
// //   Activity,
// //   BarChart3,
// //   Download,
// //   RefreshCw,
// //   Info,
// //   Wifi,
// //   WifiOff,
// //   Package,
// //   AlertTriangle,
// //   Clock
// // } from "lucide-react";
// // import { MATERIAL_SPECIFICATIONS, getMaterialSpecs, isWithinSpec, getDefectType } from '../../Materialspecs';

// // const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
// // const MONTHS = [
// //   "January", "February", "March", "April", "May", "June",
// //   "July", "August", "September", "October", "November", "December"
// // ];

// // const WidthHistoryView = () => {
// //   const today = new Date();
  
// //   const [currentMonth, setCurrentMonth] = useState(today);
// //   const [selectedDate, setSelectedDate] = useState(today.toISOString().split('T')[0]);
// //   const [loading, setLoading] = useState(false);
// //   const [allData, setAllData] = useState([]);
// //   const [filteredData, setFilteredData] = useState([]);
// //   const [statistics, setStatistics] = useState(null);
// //   const [availableDates, setAvailableDates] = useState(new Set());
// //   const [hoveredPoint, setHoveredPoint] = useState(null);
// //   const [selectedTimeRange, setSelectedTimeRange] = useState('all');
// //   const [selectedMaterial, setSelectedMaterial] = useState('all');
// //   const [availableMaterials, setAvailableMaterials] = useState([]);
// //   const [isConnected, setIsConnected] = useState(false);
// //   const [lastUpdate, setLastUpdate] = useState(null);
  
// //   const graphRef = useRef(null);
  
// //   const API_BASE = "https://oyplm85fk3.execute-api.us-east-1.amazonaws.com/prod";

// //   const fetchAllData = async () => {
// //     setLoading(true);
    
// //     try {
// //       const response = await fetch(`${API_BASE}/download?page_size=5000&order=desc`);
// //       const data = await response.json();
      
// //       if (data.success && data.data) {
// //         const processedData = data.data.map(record => {
// //           const time = new Date(record.time || record.timestamp);
// //           const materialCode = record.sensor_type || 'unknown';
// //           const specs = getMaterialSpecs(materialCode);
// //           const widthInMeters = parseFloat(record.width_meters || 0);
// //           const widthInMM = widthInMeters * 1000;
          
// //           const isDefect = widthInMM < specs.min || widthInMM > specs.max;
// //           const defectInfo = getDefectType(widthInMeters, materialCode);
          
// //           return {
// //             time: time.toLocaleTimeString('en-US', { 
// //               hour: '2-digit', 
// //               minute: '2-digit',
// //               hour12: false 
// //             }),
// //             timestamp: time,
// //             date: time.toISOString().split('T')[0],
// //             width: widthInMeters,
// //             widthMM: widthInMM,
// //             device_id: record.device_id || 'unknown',
// //             location: record.location || 'unknown',
// //             material_code: materialCode,
// //             material_name: specs.name,
// //             isDefect: isDefect,
// //             defectType: defectInfo?.type || null,
// //             deviation: defectInfo?.deviation || 0,
// //             specs: specs
// //           };
// //         });
        
// //         setAllData(processedData);
        
// //         const dates = new Set(processedData.map(d => d.date));
// //         setAvailableDates(dates);
        
// //         const materials = [...new Set(processedData.map(d => d.material_code).filter(m => m && m !== 'unknown'))];
// //         setAvailableMaterials(materials);
// //         setIsConnected(true);
// //         setLastUpdate(new Date());
        
// //         if (dates.size > 0) {
// //           const sortedDates = Array.from(dates).sort();
// //           if (!dates.has(selectedDate)) {
// //             setSelectedDate(sortedDates[sortedDates.length - 1]);
// //           }
// //         }
// //       }
// //     } catch (error) {
// //       console.error('Failed to fetch data:', error);
// //       setIsConnected(false);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchAllData();
// //   }, []);

// //   useEffect(() => {
// //     if (selectedDate && allData.length > 0) {
// //       let dayData = allData.filter(d => d.date === selectedDate);
      
// //       if (selectedMaterial !== 'all') {
// //         dayData = dayData.filter(d => d.material_code === selectedMaterial);
// //       }
      
// //       if (selectedTimeRange !== 'all') {
// //         dayData = dayData.filter(d => {
// //           const hour = d.timestamp.getHours();
// //           if (selectedTimeRange === 'morning') return hour >= 6 && hour < 12;
// //           if (selectedTimeRange === 'afternoon') return hour >= 12 && hour < 18;
// //           if (selectedTimeRange === 'evening') return hour >= 18 || hour < 6;
// //           if (selectedTimeRange === 'shift1') return hour >= 6 && hour < 14;
// //           if (selectedTimeRange === 'shift2') return hour >= 14 && hour < 22;
// //           if (selectedTimeRange === 'shift3') return hour >= 22 || hour < 6;
// //           return true;
// //         });
// //       }
      
// //       dayData.sort((a, b) => a.timestamp - b.timestamp);
      
// //       setFilteredData(dayData);
// //       setStatistics(calculateStatistics(dayData));
      
// //       console.log(`Showing ${dayData.length} data points for ${selectedDate}`);
// //     }
// //   }, [selectedDate, allData, selectedTimeRange, selectedMaterial]);

// //   const calculateStatistics = (data) => {
// //     if (!data || data.length === 0) return null;
    
// //     const widthsMM = data.map(d => d.widthMM);
// //     const defects = data.filter(d => d.isDefect);
// //     const underSpec = defects.filter(d => d.defectType === 'Under Spec');
// //     const overSpec = defects.filter(d => d.defectType === 'Over Spec');
    
// //     const goodParts = data.length - defects.length;
// //     const qualityRate = data.length > 0 ? (goodParts / data.length * 100).toFixed(1) : 100;
    
// //     const materialBreakdown = {};
// //     data.forEach(d => {
// //       if (!materialBreakdown[d.material_code]) {
// //         materialBreakdown[d.material_code] = {
// //           code: d.material_code,
// //           name: d.material_name,
// //           specs: d.specs,
// //           measurements: [],
// //           defects: 0
// //         };
// //       }
// //       materialBreakdown[d.material_code].measurements.push(d.widthMM);
// //       if (d.isDefect) materialBreakdown[d.material_code].defects++;
// //     });
    
// //     Object.values(materialBreakdown).forEach(mat => {
// //       const measurements = mat.measurements;
// //       mat.count = measurements.length;
// //       mat.average = (measurements.reduce((a, b) => a + b, 0) / measurements.length).toFixed(1);
// //       mat.qualityRate = ((mat.count - mat.defects) / mat.count * 100).toFixed(1);
// //     });
    
// //     return {
// //       average: (widthsMM.reduce((a, b) => a + b, 0) / widthsMM.length).toFixed(1),
// //       min: Math.min(...widthsMM).toFixed(1),
// //       max: Math.max(...widthsMM).toFixed(1),
// //       stdDev: calculateStdDev(widthsMM).toFixed(2),
// //       totalMeasurements: data.length,
// //       goodCount: goodParts,
// //       defectCount: defects.length,
// //       qualityRate: qualityRate,
// //       underSpec: underSpec.length,
// //       overSpec: overSpec.length,
// //       materialBreakdown: Object.values(materialBreakdown)
// //     };
// //   };

// //   const calculateStdDev = (values) => {
// //     if (values.length === 0) return 0;
// //     const mean = values.reduce((a, b) => a + b, 0) / values.length;
// //     const squaredDiffs = values.map(v => Math.pow(v - mean, 2));
// //     const avgSquaredDiff = squaredDiffs.reduce((a, b) => a + b, 0) / values.length;
// //     return Math.sqrt(avgSquaredDiff);
// //   };

// //   const generateTimeLabels = () => {
// //     if (filteredData.length === 0) return [];
    
// //     const startTime = new Date(filteredData[0].timestamp);
// //     const endTime = new Date(filteredData[filteredData.length - 1].timestamp);
// //     const duration = endTime - startTime;
// //     const durationHours = duration / (1000 * 60 * 60);
    
// //     const labels = [];
    
// //     let interval;
// //     if (durationHours <= 1) {
// //       interval = 15;
// //     } else if (durationHours <= 3) {
// //       interval = 30;
// //     } else if (durationHours <= 12) {
// //       interval = 60;
// //     } else {
// //       interval = 120;
// //     }
    
// //     const current = new Date(startTime);
// //     current.setMinutes(Math.floor(current.getMinutes() / interval) * interval, 0, 0);
    
// //     while (current <= endTime) {
// //       labels.push({
// //         time: new Date(current),
// //         label: current.toLocaleTimeString('en-US', { 
// //           hour: '2-digit', 
// //           minute: '2-digit',
// //           hour12: false 
// //         })
// //       });
// //       current.setMinutes(current.getMinutes() + interval);
// //     }
    
// //     return labels.length > 20 ? labels.filter((l, i) => i % 2 === 0) : labels;
// //   };

// //   const getCalendarDays = () => {
// //     const year = currentMonth.getFullYear();
// //     const month = currentMonth.getMonth();
// //     const firstDay = new Date(year, month, 1).getDay();
// //     const daysInMonth = new Date(year, month + 1, 0).getDate();
// //     const days = [];
    
// //     const todayStr = today.toLocaleDateString('en-CA');

// //     for (let i = 0; i < firstDay; i++) {
// //       days.push(null);
// //     }

// //     for (let day = 1; day <= daysInMonth; day++) {
// //       const date = new Date(year, month, day);
// //       const dateStr = date.toLocaleDateString('en-CA');
// //       days.push({
// //         date: day,
// //         dateStr,
// //         hasData: availableDates.has(dateStr),
// //         isToday: dateStr === todayStr,
// //       });
// //     }

// //     return days;
// //   };

// //   const handleDateSelect = (dateStr) => {
// //     if (!dateStr || !availableDates.has(dateStr)) return;
// //     setSelectedDate(dateStr);
// //   };

// //   const formatDate = (dateStr) => {
// //     if (!dateStr) return "";
// //     const date = new Date(dateStr + 'T00:00:00');
// //     return `${MONTHS[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
// //   };

// //   const downloadCSV = () => {
// //     if (filteredData.length === 0) return;
    
// //     const headers = ['Time', 'Width (mm)', 'Material Code', 'Material Name', 'Min Spec', 'Max Spec', 'Status', 'Device', 'Location'];
// //     const rows = filteredData.map(d => [
// //       d.timestamp.toISOString(),
// //       d.widthMM.toFixed(1),
// //       d.material_code,
// //       d.material_name,
// //       d.specs.min,
// //       d.specs.max,
// //       d.isDefect ? `${d.defectType} (${d.deviation.toFixed(1)}mm)` : 'Normal',
// //       d.device_id,
// //       d.location
// //     ]);
    
// //     const csvContent = [
// //       headers.join(','),
// //       ...rows.map(row => row.join(','))
// //     ].join('\n');
    
// //     const blob = new Blob([csvContent], { type: 'text/csv' });
// //     const url = URL.createObjectURL(blob);
// //     const a = document.createElement('a');
// //     a.href = url;
// //     a.download = `width_data_${selectedDate}.csv`;
// //     a.click();
// //     URL.revokeObjectURL(url);
// //   };

// //   const currentMaterialSpecs = selectedMaterial !== 'all' 
// //     ? getMaterialSpecs(selectedMaterial)
// //     : null;

// //   const graphWidth = 900;
// //   const graphHeight = 350;
// //   const padding = { top: 30, right: 20, bottom: 60, left: 60 };
// //   const chartWidth = graphWidth - padding.left - padding.right;
// //   const chartHeight = graphHeight - padding.top - padding.bottom;

// //   const xScale = (timestamp) => {
// //     if (filteredData.length === 0) return 0;
// //     const minTime = filteredData[0].timestamp.getTime();
// //     const maxTime = filteredData[filteredData.length - 1].timestamp.getTime();
// //     const range = maxTime - minTime || 1;
// //     return ((timestamp.getTime() - minTime) / range) * chartWidth;
// //   };
  
// //   const yScale = (widthMM) => {
// //     let minRange = 500;
// //     let maxRange = 600;
    
// //     if (currentMaterialSpecs) {
// //       minRange = currentMaterialSpecs.min - 10;
// //       maxRange = currentMaterialSpecs.max + 10;
// //     } else if (filteredData.length > 0) {
// //       const widths = filteredData.map(d => d.widthMM);
// //       minRange = Math.min(...widths) - 5;
// //       maxRange = Math.max(...widths) + 5;
// //     }
    
// //     return chartHeight - ((widthMM - minRange) / (maxRange - minRange)) * chartHeight;
// //   };

// //   const getYAxisLabels = () => {
// //     const labels = [];
// //     let minRange = 500;
// //     let maxRange = 600;
    
// //     if (currentMaterialSpecs) {
// //       minRange = currentMaterialSpecs.min - 10;
// //       maxRange = currentMaterialSpecs.max + 10;
// //     } else if (filteredData.length > 0) {
// //       const widths = filteredData.map(d => d.widthMM);
// //       minRange = Math.min(...widths) - 5;
// //       maxRange = Math.max(...widths) + 5;
// //     }
    
// //     const step = (maxRange - minRange) / 10;
// //     for (let i = 0; i <= 10; i++) {
// //       labels.push(minRange + (step * i));
// //     }
    
// //     if (currentMaterialSpecs) {
// //       labels.push(currentMaterialSpecs.min, currentMaterialSpecs.max, currentMaterialSpecs.film_width);
// //     }
    
// //     return [...new Set(labels)].sort((a, b) => a - b);
// //   };

// //   const getDataPointRadius = () => {
// //     const pointCount = filteredData.length;
// //     if (pointCount > 500) return 1;
// //     if (pointCount > 200) return 1.5;
// //     if (pointCount > 100) return 2;
// //     return 2.5;
// //   };

// //   return (
// //     <div className="h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 p-3 overflow-hidden">
// //       <div className="h-full flex flex-col">
// //         <div className="mb-3 flex items-center justify-between">
// //           <h1 className="text-2xl font-bold text-white flex items-center gap-2">
// //             <BarChart3 className="h-6 w-6 text-cyan-400" />
// //             Width Measurement History
// //           </h1>
// //           <div className="flex items-center gap-3">
// //             <div className="flex items-center gap-2">
// //               {isConnected ? (
// //                 <Wifi className="h-4 w-4 text-emerald-400" />
// //               ) : (
// //                 <WifiOff className="h-4 w-4 text-red-400" />
// //               )}
// //               <span className={`text-xs ${isConnected ? 'text-emerald-400' : 'text-red-400'}`}>
// //                 {isConnected ? 'Connected' : 'Offline'}
// //               </span>
// //             </div>
            
// //             <span className="text-lg font-semibold text-white">
// //               {formatDate(selectedDate)}
// //             </span>
            
// //             <select
// //               value={selectedMaterial}
// //               onChange={(e) => setSelectedMaterial(e.target.value)}
// //               className="bg-slate-800 text-white px-2 py-1 rounded-lg text-sm border border-slate-700 focus:border-cyan-400 focus:outline-none max-w-xs"
// //             >
// //               <option value="all">All Materials</option>
// //               {availableMaterials.map(code => (
// //                 <option key={code} value={code}>
// //                   {code} - {MATERIAL_SPECIFICATIONS[code]?.name.substring(0, 30) || code}
// //                 </option>
// //               ))}
// //             </select>
            
// //             <select
// //               value={selectedTimeRange}
// //               onChange={(e) => setSelectedTimeRange(e.target.value)}
// //               className="bg-slate-800 text-white px-2 py-1 rounded-lg text-sm border border-slate-700 focus:border-cyan-400 focus:outline-none"
// //             >
// //               <option value="all">All Day</option>
// //               <option value="shift1">Shift 1 (06:00-14:00)</option>
// //               <option value="shift2">Shift 2 (14:00-22:00)</option>
// //               <option value="shift3">Shift 3 (22:00-06:00)</option>
// //               <option value="morning">Morning (6AM-12PM)</option>
// //               <option value="afternoon">Afternoon (12PM-6PM)</option>
// //               <option value="evening">Evening (6PM-6AM)</option>
// //             </select>
            
// //             <button 
// //               onClick={fetchAllData}
// //               className="p-1.5 bg-slate-800 hover:bg-slate-700 rounded-lg transition-colors"
// //             >
// //               <RefreshCw className={`h-4 w-4 text-white ${loading ? 'animate-spin' : ''}`} />
// //             </button>
// //             <button 
// //               onClick={downloadCSV}
// //               className="p-1.5 bg-slate-800 hover:bg-slate-700 rounded-lg transition-colors"
// //               disabled={filteredData.length === 0}
// //             >
// //               <Download className="h-4 w-4 text-white" />
// //             </button>
// //           </div>
// //         </div>

// //         <div className="flex-1 flex gap-3">
// //           <div className="flex-1 flex flex-col gap-3">
// //             <div className="bg-slate-900/80 backdrop-blur-xl rounded-xl border border-slate-800 p-4 flex-1">
// //               <div className="mb-2 flex items-center justify-between">
// //                 <h2 className="text-lg font-semibold text-white flex items-center gap-2">
// //                   <Activity className="h-4 w-4 text-green-400" />
// //                   Width Measurements
// //                   <span className="text-sm font-normal text-slate-400">
// //                     ({statistics?.totalMeasurements || 0} points)
// //                   </span>
// //                 </h2>
                
// //                 {currentMaterialSpecs && (
// //                   <div className="flex items-center gap-2 px-3 py-1 bg-slate-800 rounded-lg">
// //                     <Package className="h-4 w-4 text-cyan-400" />
// //                     <span className="text-sm text-white font-medium">{selectedMaterial}</span>
// //                     <span className="text-xs text-slate-400">
// //                       (Target: {currentMaterialSpecs.film_width}mm, Range: {currentMaterialSpecs.min}-{currentMaterialSpecs.max}mm)
// //                     </span>
// //                   </div>
// //                 )}
// //               </div>

// //               {loading ? (
// //                 <div className="h-full flex items-center justify-center">
// //                   <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-cyan-400" />
// //                 </div>
// //               ) : filteredData.length === 0 ? (
// //                 <div className="h-full flex items-center justify-center">
// //                   <p className="text-slate-400">No data available for selected filters</p>
// //                 </div>
// //               ) : (
// //                 <div className="relative h-full">
// //                   <svg
// //                     ref={graphRef}
// //                     width="100%"
// //                     height="100%"
// //                     viewBox={`0 0 ${graphWidth} ${graphHeight}`}
// //                     preserveAspectRatio="xMidYMid meet"
// //                   >
// //                     <g transform={`translate(${padding.left}, ${padding.top})`}>
// //                       {getYAxisLabels().map(value => {
// //                         const y = yScale(value);
// //                         const isSpecLimit = currentMaterialSpecs && 
// //                           (value === currentMaterialSpecs.min || value === currentMaterialSpecs.max);
// //                         const isTarget = currentMaterialSpecs && value === currentMaterialSpecs.film_width;
                        
// //                         return (
// //                           <g key={value}>
// //                             <line
// //                               x1={0}
// //                               y1={y}
// //                               x2={chartWidth}
// //                               y2={y}
// //                               stroke={
// //                                 isSpecLimit ? "rgba(239, 68, 68, 0.3)" : 
// //                                 isTarget ? "rgba(16, 185, 129, 0.3)" :
// //                                 "rgba(148, 163, 184, 0.1)"
// //                               }
// //                               strokeDasharray={isSpecLimit || isTarget ? "0" : "5,5"}
// //                               strokeWidth={isSpecLimit || isTarget ? "1.5" : "1"}
// //                             />
// //                             <text
// //                               x={-8}
// //                               y={y + 3}
// //                               fill={
// //                                 isSpecLimit ? "#ef4444" :
// //                                 isTarget ? "#10b981" :
// //                                 "#94a3b8"
// //                               }
// //                               fontSize="10"
// //                               textAnchor="end"
// //                             >
// //                               {value.toFixed(0)}
// //                             </text>
// //                           </g>
// //                         );
// //                       })}
                      
// //                       {currentMaterialSpecs && (
// //                         <rect
// //                           x={0}
// //                           y={yScale(currentMaterialSpecs.max)}
// //                           width={chartWidth}
// //                           height={yScale(currentMaterialSpecs.min) - yScale(currentMaterialSpecs.max)}
// //                           fill="rgba(16, 185, 129, 0.05)"
// //                           stroke="none"
// //                         />
// //                       )}
                      
// //                       {filteredData.length > 1 && (
// //                         <polyline
// //                           fill="none"
// //                           stroke="#06b6d4"
// //                           strokeWidth={filteredData.length > 200 ? "0.8" : "1.5"}
// //                           strokeOpacity="0.8"
// //                           points={filteredData.map(d => 
// //                             `${xScale(d.timestamp)},${yScale(d.widthMM)}`
// //                           ).join(' ')}
// //                         />
// //                       )}
                      
// //                       {filteredData.map((d, i) => {
// //                         const radius = getDataPointRadius();
// //                         return (
// //                           <circle
// //                             key={i}
// //                             cx={xScale(d.timestamp)}
// //                             cy={yScale(d.widthMM)}
// //                             r={d.isDefect ? radius * 2 : radius}
// //                             fill={d.isDefect ? "#ef4444" : "#06b6d4"}
// //                             fillOpacity={d.isDefect ? 0.9 : 0.6}
// //                             stroke={d.isDefect ? "#dc2626" : "none"}
// //                             strokeWidth={d.isDefect ? 1 : 0}
// //                             className="cursor-pointer"
// //                             onMouseEnter={() => setHoveredPoint({ ...d, index: i })}
// //                             onMouseLeave={() => setHoveredPoint(null)}
// //                           />
// //                         );
// //                       })}
                      
// //                       <line x1={0} y1={chartHeight} x2={chartWidth} y2={chartHeight} stroke="#475569" strokeWidth="2" />
                      
// //                       {generateTimeLabels().map((label, idx) => {
// //                         const x = xScale(label.time);
                        
// //                         return (
// //                           <g key={idx}>
// //                             <line
// //                               x1={x}
// //                               y1={chartHeight}
// //                               x2={x}
// //                               y2={chartHeight + 5}
// //                               stroke="#475569"
// //                             />
// //                             <text
// //                               x={x}
// //                               y={chartHeight + 20}
// //                               fill="#94a3b8"
// //                               fontSize="10"
// //                               textAnchor="middle"
// //                               transform={`rotate(-45, ${x}, ${chartHeight + 20})`}
// //                             >
// //                               {label.label}
// //                             </text>
// //                           </g>
// //                         );
// //                       })}
                      
// //                       <line x1={0} y1={0} x2={0} y2={chartHeight} stroke="#475569" strokeWidth="2" />
                      
// //                       <text
// //                         x={chartWidth / 2}
// //                         y={chartHeight + 50}
// //                         fill="#94a3b8"
// //                         fontSize="12"
// //                         textAnchor="middle"
// //                         fontWeight="500"
// //                       >
// //                         Time (24-Hour Format)
// //                       </text>
                      
// //                       <text
// //                         x={-chartHeight / 2}
// //                         y={-40}
// //                         fill="#94a3b8"
// //                         fontSize="12"
// //                         textAnchor="middle"
// //                         transform="rotate(-90)"
// //                         fontWeight="500"
// //                       >
// //                         Width (mm)
// //                       </text>
// //                     </g>
// //                   </svg>
                  
// //                   {hoveredPoint && (
// //                     <div className="absolute bg-slate-800 border border-slate-600 rounded-lg p-2 pointer-events-none z-10"
// //                       style={{
// //                         left: '50%',
// //                         top: '20%',
// //                         transform: 'translate(-50%, -50%)'
// //                       }}
// //                     >
// //                       <p className="text-xs text-white font-semibold">
// //                         {hoveredPoint.timestamp.toLocaleString('en-US', {
// //                           hour: '2-digit',
// //                           minute: '2-digit',
// //                           second: '2-digit',
// //                           hour12: false
// //                         })}
// //                       </p>
// //                       <p className="text-xs text-cyan-400">Width: {hoveredPoint.widthMM.toFixed(1)}mm</p>
// //                       <p className="text-xs text-purple-400">Material: {hoveredPoint.material_code}</p>
// //                       <p className="text-xs text-slate-300">{hoveredPoint.material_name}</p>
// //                       <p className="text-xs text-slate-300">Device: {hoveredPoint.device_id}</p>
// //                       {hoveredPoint.isDefect && (
// //                         <>
// //                           <p className="text-xs text-red-400 font-bold">{hoveredPoint.defectType}</p>
// //                           <p className="text-xs text-red-400">Deviation: {hoveredPoint.deviation.toFixed(1)}mm</p>
// //                         </>
// //                       )}
// //                       <p className="text-xs text-slate-400 mt-1">
// //                         Spec: {hoveredPoint.specs.min}-{hoveredPoint.specs.max}mm
// //                       </p>
// //                     </div>
// //                   )}
// //                 </div>
// //               )}
// //             </div>

// //             <div className="flex gap-3">
// //               <div className="flex-1 bg-slate-900/80 backdrop-blur-xl rounded-lg border border-slate-800 p-3">
// //                 <div className="flex items-center justify-between">
// //                   <div>
// //                     <p className="text-xs text-slate-400">Average</p>
// //                     <p className="text-lg font-bold text-white">{statistics?.average || '--'}mm</p>
// //                     <p className="text-xs text-slate-500">σ = {statistics?.stdDev || '--'}</p>
// //                   </div>
// //                   <Activity className="h-5 w-5 text-purple-400" />
// //                 </div>
// //               </div>
              
// //               <div className="flex-1 bg-slate-900/80 backdrop-blur-xl rounded-lg border border-slate-800 p-3">
// //                 <div className="flex items-center justify-between">
// //                   <div>
// //                     <p className="text-xs text-slate-400">Defects</p>
// //                     <p className="text-lg font-bold text-red-400">{statistics?.defectCount || 0}</p>
// //                     <p className="text-xs text-slate-500">
// //                       {statistics?.underSpec || 0}↓ / {statistics?.overSpec || 0}↑
// //                     </p>
// //                   </div>
// //                   <AlertTriangle className="h-5 w-5 text-red-400" />
// //                 </div>
// //               </div>
              
// //               <div className="flex-1 bg-slate-900/80 backdrop-blur-xl rounded-lg border border-slate-800 p-3">
// //                 <div className="flex items-center justify-between">
// //                   <div>
// //                     <p className="text-xs text-slate-400">Quality Rate</p>
// //                     <p className="text-lg font-bold text-emerald-400">{statistics?.qualityRate || '100'}%</p>
// //                     <p className="text-xs text-slate-500">{statistics?.totalMeasurements || 0} total</p>
// //                   </div>
// //                   <BarChart3 className="h-5 w-5 text-cyan-400" />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>

// //           <div className="w-72 flex flex-col gap-3">
// //             <div className="bg-slate-900/80 backdrop-blur-xl rounded-xl border border-slate-800 p-3">
// //               <div className="flex items-center justify-between mb-2">
// //                 <button
// //                   onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1))}
// //                   className="p-0.5 hover:bg-slate-800 rounded-lg transition-colors"
// //                 >
// //                   <ChevronLeft className="h-4 w-4 text-white" />
// //                 </button>
// //                 <span className="text-sm font-medium text-white">
// //                   {MONTHS[currentMonth.getMonth()].slice(0, 3)} {currentMonth.getFullYear()}
// //                 </span>
// //                 <button
// //                   onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1))}
// //                   className="p-0.5 hover:bg-slate-800 rounded-lg transition-colors"
// //                 >
// //                   <ChevronRight className="h-4 w-4 text-white" />
// //                 </button>
// //               </div>
              
// //               <div className="grid grid-cols-7 gap-1 mb-1">
// //                 {DAYS_OF_WEEK.map((day, index) => (
// //                   <div key={`day-${index}`} className="text-center text-xs font-medium text-slate-400">
// //                     {day}
// //                   </div>
// //                 ))}
// //               </div>
              
// //               <div className="grid grid-cols-7 gap-0.5">
// //                 {getCalendarDays().map((day, idx) => (
// //                   <div key={`cal-${idx}`} className="aspect-square">
// //                     {day && (
// //                       <button
// //                         onClick={() => day.hasData && handleDateSelect(day.dateStr)}
// //                         disabled={!day.hasData}
// //                         className={`w-full h-full flex items-center justify-center rounded text-xs font-medium transition-all
// //                           ${day.hasData ? "hover:bg-slate-800 cursor-pointer" : "text-slate-700 cursor-not-allowed"}
// //                           ${day.isToday ? "ring-1 ring-emerald-500 text-emerald-400" : ""}
// //                           ${day.dateStr === selectedDate ? "bg-cyan-500 text-white" : ""}
// //                           ${day.hasData && !day.isToday && day.dateStr !== selectedDate ? "text-cyan-400" : ""}`}
// //                       >
// //                         {day.date}
// //                       </button>
// //                     )}
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>
            
// //             <div className="bg-slate-900/80 backdrop-blur-xl rounded-xl border border-slate-800 p-3 flex-1">
// //               <h3 className="text-sm font-semibold text-white mb-2 flex items-center gap-2">
// //                 <Package className="h-4 w-4 text-cyan-400" />
// //                 Material Analysis
// //               </h3>
              
// //               {statistics?.materialBreakdown && statistics.materialBreakdown.length > 0 ? (
// //                 <div className="space-y-2 max-h-64 overflow-y-auto">
// //                   {statistics.materialBreakdown.map((mat) => (
// //                     <div key={mat.code} className="border border-slate-700 rounded-lg p-2">
// //                       <div className="flex justify-between items-start">
// //                         <div className="flex-1">
// //                           <p className="text-xs font-medium text-cyan-400">{mat.code}</p>
// //                           <p className="text-xs text-slate-400 truncate" title={mat.name}>
// //                             {mat.name.substring(0, 25)}...
// //                           </p>
// //                         </div>
// //                       </div>
// //                       <div className="mt-1 grid grid-cols-2 gap-1 text-xs">
// //                         <div>
// //                           <span className="text-slate-500">Count:</span>
// //                           <span className="text-white ml-1">{mat.count}</span>
// //                         </div>
// //                         <div>
// //                           <span className="text-slate-500">Defects:</span>
// //                           <span className={`ml-1 ${mat.defects > 0 ? 'text-red-400' : 'text-green-400'}`}>
// //                             {mat.defects}
// //                           </span>
// //                         </div>
// //                         <div>
// //                           <span className="text-slate-500">Avg:</span>
// //                           <span className="text-white ml-1">{mat.average}mm</span>
// //                         </div>
// //                         <div>
// //                           <span className="text-slate-500">Quality:</span>
// //                           <span className={`ml-1 ${parseFloat(mat.qualityRate) >= 95 ? 'text-green-400' : 'text-yellow-400'}`}>
// //                             {mat.qualityRate}%
// //                           </span>
// //                         </div>
// //                       </div>
// //                       <div className="mt-1 text-xs text-slate-500">
// //                         Target: {mat.specs.film_width}mm ({mat.specs.min}-{mat.specs.max}mm)
// //                       </div>
// //                     </div>
// //                   ))}
// //                 </div>
// //               ) : (
// //                 <p className="text-xs text-slate-400">No material data available</p>
// //               )}
              
// //               <div className="mt-3 pt-3 border-t border-slate-800">
// //                 <div className="flex items-center gap-2 text-xs text-slate-400">
// //                   <Clock className="h-3 w-3" />
// //                   <span>Data Range: {filteredData.length > 0 ? 
// //                     `${filteredData[0].time} - ${filteredData[filteredData.length - 1].time}` : 
// //                     'No data'}</span>
// //                 </div>
// //                 {lastUpdate && (
// //                   <p className="text-xs text-slate-500 mt-1">
// //                     Last updated: {lastUpdate.toLocaleTimeString()}
// //                   </p>
// //                 )}
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default WidthHistoryView;

// import React, { useState, useEffect, useRef } from "react";
// import {
//   ChevronLeft,
//   ChevronRight,
//   Activity,
//   BarChart3,
//   Download,
//   RefreshCw,
//   Wifi,
//   WifiOff,
//   Package,
//   AlertTriangle,
//   Clock,
//   Layers
// } from "lucide-react";
// import { MATERIAL_SPECIFICATIONS, getMaterialSpecs, getDefectType } from '../../Materialspecs';

// const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
// const MONTHS = [
//   "January", "February", "March", "April", "May", "June",
//   "July", "August", "September", "October", "November", "December"
// ];

// const WidthHistoryView = () => {
//   const today = new Date();
  
//   const [currentMonth, setCurrentMonth] = useState(new Date(2025, 11, 1));
//   const [selectedDate, setSelectedDate] = useState('2025-12-26');
//   const [loading, setLoading] = useState(false);
//   const [allData, setAllData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [statistics, setStatistics] = useState(null);
//   const [availableDates, setAvailableDates] = useState(new Set(['2025-12-26']));
//   const [hoveredPoint, setHoveredPoint] = useState(null);
//   const [selectedTimeRange, setSelectedTimeRange] = useState('all');
//   const [selectedMaterial, setSelectedMaterial] = useState('all');
//   const [availableMaterials, setAvailableMaterials] = useState([]);
//   const [isConnected, setIsConnected] = useState(false);
//   const [lastUpdate, setLastUpdate] = useState(null);
//   const [isAggregated, setIsAggregated] = useState(false);
//   const [totalRawRecords, setTotalRawRecords] = useState(0);
//   const [errorMessage, setErrorMessage] = useState(null);
  
//   const graphRef = useRef(null);
  
//   const API_BASE = "https://oyplm85fk3.execute-api.us-east-1.amazonaws.com/prod";

//   useEffect(() => {
//     fetchAvailableDates();
//   }, []);

//   const fetchAvailableDates = async () => {
//     try {
//       const response = await fetch(`${API_BASE}/dates`);
//       if (!response.ok) throw new Error(`HTTP ${response.status}`);
      
//       const data = await response.json();
      
//       if (data.success && data.dates) {
//         const dates = new Set(data.dates.map(d => d.date));
//         setAvailableDates(dates);
        
//         if (data.materials) {
//           setAvailableMaterials(data.materials.filter(m => m && m !== 'unknown'));
//         }
        
//         setIsConnected(true);
//         setErrorMessage(null);
        
//         if (dates.size > 0) {
//           const sortedDates = Array.from(dates).sort();
//           const mostRecent = sortedDates[sortedDates.length - 1];
//           setSelectedDate(mostRecent);
//         }
//       }
//     } catch (error) {
//       console.error('Failed to fetch dates:', error);
//     }
//   };

//   const downsampleData = (data, maxPoints = 1000) => {
//     if (data.length <= maxPoints) return { data, downsampled: false };
    
//     const step = Math.ceil(data.length / maxPoints);
//     const downsampled = [];
    
//     for (let i = 0; i < data.length; i += step) {
//       const chunk = data.slice(i, Math.min(i + step, data.length));
      
//       const avgWidth = chunk.reduce((sum, d) => sum + d.widthMM, 0) / chunk.length;
//       const minWidth = Math.min(...chunk.map(d => d.widthMM));
//       const maxWidth = Math.max(...chunk.map(d => d.widthMM));
      
//       downsampled.push({
//         ...chunk[0],
//         widthMM: avgWidth,
//         widthMinMM: minWidth,
//         widthMaxMM: maxWidth,
//         sampleCount: chunk.reduce((sum, d) => sum + (d.sampleCount || 1), 0),
//         isAggregated: true
//       });
//     }
    
//     return { data: downsampled, downsampled: true };
//   };

//   const fetchDailyData = async () => {
//     if (!selectedDate) return;
    
//     setLoading(true);
//     setErrorMessage(null);
    
//     try {
//       const url = `${API_BASE}/download?date=${selectedDate}&bin_minutes=5`;
//       console.log('Fetching:', url);
      
//       const response = await fetch(url);
      
//       if (!response.ok) {
//         throw new Error(`HTTP ${response.status}: ${response.statusText}`);
//       }
      
//       const data = await response.json();
      
//       if (data.success && data.data) {
//         let processedData = data.data.map(record => {
//           const time = new Date(record.time || record.timestamp);
//           const materialCode = record.sensor_type || 'unknown';
//           const specs = getMaterialSpecs(materialCode);
          
//           const widthInMeters = parseFloat(record.width_meters || 0);
//           const widthInMM = widthInMeters * 1000;
          
//           const widthMinMM = record.width_min ? parseFloat(record.width_min) * 1000 : widthInMM;
//           const widthMaxMM = record.width_max ? parseFloat(record.width_max) * 1000 : widthInMM;
          
//           const isDefect = widthInMM < specs.min || widthInMM > specs.max;
//           const defectInfo = getDefectType(widthInMeters, materialCode);
          
//           return {
//             time: time.toLocaleTimeString('en-US', { 
//               hour: '2-digit', 
//               minute: '2-digit',
//               hour12: false 
//             }),
//             timestamp: time,
//             date: time.toISOString().split('T')[0],
//             width: widthInMeters,
//             widthMM: widthInMM,
//             widthMinMM: widthMinMM,
//             widthMaxMM: widthMaxMM,
//             sampleCount: record.sample_count || 1,
//             device_id: record.device_id || 'unknown',
//             location: record.location || 'unknown',
//             material_code: materialCode,
//             material_name: specs.name,
//             isDefect: isDefect,
//             defectType: defectInfo?.type || null,
//             deviation: defectInfo?.deviation || 0,
//             specs: specs
//           };
//         });
        
//         processedData.sort((a, b) => a.timestamp - b.timestamp);
        
//         const { data: finalData, downsampled } = downsampleData(processedData, 1500);
        
//         setAllData(finalData);
//         setIsAggregated(data.aggregated || downsampled);
//         setTotalRawRecords(data.total_records || processedData.reduce((sum, d) => sum + (d.sampleCount || 1), 0));
//         setIsConnected(true);
//         setLastUpdate(new Date());
        
//         const materials = [...new Set(finalData.map(d => d.material_code).filter(m => m && m !== 'unknown'))];
//         if (materials.length > 0) {
//           setAvailableMaterials(prev => [...new Set([...prev, ...materials])]);
//         }
        
//         console.log(`Loaded ${finalData.length} data points for ${selectedDate}`);
//       } else {
//         setAllData([]);
//         setErrorMessage(data.error || 'No data returned');
//       }
//     } catch (error) {
//       console.error('Failed to fetch daily data:', error);
//       setIsConnected(false);
//       setErrorMessage(error.message);
//       setAllData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (selectedDate) {
//       fetchDailyData();
//     }
//   }, [selectedDate]);

//   useEffect(() => {
//     if (allData.length > 0) {
//       let dayData = [...allData];
      
//       if (selectedMaterial !== 'all') {
//         dayData = dayData.filter(d => d.material_code === selectedMaterial);
//       }
      
//       if (selectedTimeRange !== 'all') {
//         dayData = dayData.filter(d => {
//           const hour = d.timestamp.getHours();
//           if (selectedTimeRange === 'morning') return hour >= 6 && hour < 12;
//           if (selectedTimeRange === 'afternoon') return hour >= 12 && hour < 18;
//           if (selectedTimeRange === 'evening') return hour >= 18 || hour < 6;
//           if (selectedTimeRange === 'shift1') return hour >= 6 && hour < 14;
//           if (selectedTimeRange === 'shift2') return hour >= 14 && hour < 22;
//           if (selectedTimeRange === 'shift3') return hour >= 22 || hour < 6;
//           return true;
//         });
//       }
      
//       dayData.sort((a, b) => a.timestamp - b.timestamp);
      
//       setFilteredData(dayData);
//       setStatistics(calculateStatistics(dayData));
//     } else {
//       setFilteredData([]);
//       setStatistics(null);
//     }
//   }, [allData, selectedTimeRange, selectedMaterial]);

//   const calculateStatistics = (data) => {
//     if (!data || data.length === 0) return null;
    
//     const widthsMM = data.map(d => d.widthMM);
//     const defects = data.filter(d => d.isDefect);
//     const underSpec = defects.filter(d => d.defectType === 'Under Spec');
//     const overSpec = defects.filter(d => d.defectType === 'Over Spec');
    
//     const totalSamples = data.reduce((sum, d) => sum + (d.sampleCount || 1), 0);
    
//     const goodParts = data.length - defects.length;
//     const qualityRate = data.length > 0 ? (goodParts / data.length * 100).toFixed(1) : 100;
    
//     const materialBreakdown = {};
//     data.forEach(d => {
//       if (!materialBreakdown[d.material_code]) {
//         materialBreakdown[d.material_code] = {
//           code: d.material_code,
//           name: d.material_name,
//           specs: d.specs,
//           measurements: [],
//           defects: 0,
//           totalSamples: 0
//         };
//       }
//       materialBreakdown[d.material_code].measurements.push(d.widthMM);
//       materialBreakdown[d.material_code].totalSamples += (d.sampleCount || 1);
//       if (d.isDefect) materialBreakdown[d.material_code].defects++;
//     });
    
//     Object.values(materialBreakdown).forEach(mat => {
//       const measurements = mat.measurements;
//       mat.count = measurements.length;
//       mat.average = (measurements.reduce((a, b) => a + b, 0) / measurements.length).toFixed(1);
//       mat.qualityRate = ((mat.count - mat.defects) / mat.count * 100).toFixed(1);
//     });
    
//     return {
//       average: (widthsMM.reduce((a, b) => a + b, 0) / widthsMM.length).toFixed(1),
//       min: Math.min(...widthsMM).toFixed(1),
//       max: Math.max(...widthsMM).toFixed(1),
//       stdDev: calculateStdDev(widthsMM).toFixed(2),
//       totalMeasurements: data.length,
//       totalSamples: totalSamples,
//       goodCount: goodParts,
//       defectCount: defects.length,
//       qualityRate: qualityRate,
//       underSpec: underSpec.length,
//       overSpec: overSpec.length,
//       materialBreakdown: Object.values(materialBreakdown)
//     };
//   };

//   const calculateStdDev = (values) => {
//     if (values.length === 0) return 0;
//     const mean = values.reduce((a, b) => a + b, 0) / values.length;
//     const squaredDiffs = values.map(v => Math.pow(v - mean, 2));
//     const avgSquaredDiff = squaredDiffs.reduce((a, b) => a + b, 0) / values.length;
//     return Math.sqrt(avgSquaredDiff);
//   };

//   // Generate time labels for FULL 24-hour day
//   const generateTimeLabels = () => {
//     const labels = [];
    
//     // Always show full 24-hour day with 2-hour intervals
//     for (let hour = 0; hour <= 24; hour += 2) {
//       const h = hour.toString().padStart(2, '0');
//       labels.push({
//         hour: hour,
//         label: `${h}:00`
//       });
//     }
    
//     return labels;
//   };

//   // Get actual data time range for display
//   const getDataTimeRange = () => {
//     if (filteredData.length === 0) return { start: 'No data', end: '' };
    
//     const startTime = filteredData[0].timestamp;
//     const endTime = filteredData[filteredData.length - 1].timestamp;
    
//     return {
//       start: startTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false }),
//       end: endTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false })
//     };
//   };

//   const getCalendarDays = () => {
//     const year = currentMonth.getFullYear();
//     const month = currentMonth.getMonth();
//     const firstDay = new Date(year, month, 1).getDay();
//     const daysInMonth = new Date(year, month + 1, 0).getDate();
//     const days = [];
    
//     const todayStr = today.toLocaleDateString('en-CA');

//     for (let i = 0; i < firstDay; i++) days.push(null);

//     for (let day = 1; day <= daysInMonth; day++) {
//       const date = new Date(year, month, day);
//       const dateStr = date.toLocaleDateString('en-CA');
//       days.push({
//         date: day,
//         dateStr,
//         hasData: availableDates.has(dateStr),
//         isToday: dateStr === todayStr,
//       });
//     }

//     return days;
//   };

//   const handleDateSelect = (dateStr) => {
//     if (!dateStr) return;
//     setSelectedDate(dateStr);
//   };

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "";
//     const date = new Date(dateStr + 'T00:00:00');
//     return `${MONTHS[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
//   };

//   const downloadCSV = () => {
//     if (filteredData.length === 0) return;
    
//     const headers = ['Time', 'Width (mm)', 'Samples', 'Material Code', 'Status', 'Device'];
//     const rows = filteredData.map(d => [
//       d.timestamp.toISOString(),
//       d.widthMM.toFixed(1),
//       d.sampleCount,
//       d.material_code,
//       d.isDefect ? d.defectType : 'Normal',
//       d.device_id
//     ]);
    
//     const csvContent = [headers.join(','), ...rows.map(row => row.join(','))].join('\n');
    
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `width_data_${selectedDate}.csv`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   const currentMaterialSpecs = selectedMaterial !== 'all' ? getMaterialSpecs(selectedMaterial) : null;

//   const graphWidth = 900;
//   const graphHeight = 350;
//   const padding = { top: 30, right: 20, bottom: 60, left: 60 };
//   const chartWidth = graphWidth - padding.left - padding.right;
//   const chartHeight = graphHeight - padding.top - padding.bottom;

//   // X scale for FULL 24-hour day (0-24 hours)
//   const xScale = (timestamp) => {
//     const hours = timestamp.getHours() + timestamp.getMinutes() / 60 + timestamp.getSeconds() / 3600;
//     return (hours / 24) * chartWidth;
//   };

//   // X scale for hour labels
//   const xScaleHour = (hour) => {
//     return (hour / 24) * chartWidth;
//   };
  
//   const yScale = (widthMM) => {
//     let minRange = 500, maxRange = 600;
    
//     if (currentMaterialSpecs) {
//       minRange = currentMaterialSpecs.min - 10;
//       maxRange = currentMaterialSpecs.max + 10;
//     } else if (filteredData.length > 0) {
//       const widths = filteredData.map(d => d.widthMM);
//       minRange = Math.min(...widths) - 5;
//       maxRange = Math.max(...widths) + 5;
//     }
    
//     return chartHeight - ((widthMM - minRange) / (maxRange - minRange)) * chartHeight;
//   };

//   const getYAxisLabels = () => {
//     const labels = [];
//     let minRange = 500, maxRange = 600;
    
//     if (currentMaterialSpecs) {
//       minRange = currentMaterialSpecs.min - 10;
//       maxRange = currentMaterialSpecs.max + 10;
//     } else if (filteredData.length > 0) {
//       const widths = filteredData.map(d => d.widthMM);
//       minRange = Math.min(...widths) - 5;
//       maxRange = Math.max(...widths) + 5;
//     }
    
//     const step = (maxRange - minRange) / 10;
//     for (let i = 0; i <= 10; i++) labels.push(minRange + (step * i));
    
//     if (currentMaterialSpecs) {
//       labels.push(currentMaterialSpecs.min, currentMaterialSpecs.max, currentMaterialSpecs.film_width);
//     }
    
//     return [...new Set(labels)].sort((a, b) => a - b);
//   };

//   const getDataPointRadius = () => {
//     const pointCount = filteredData.length;
//     if (pointCount > 500) return 1.5;
//     if (pointCount > 200) return 2;
//     if (pointCount > 100) return 2.5;
//     return 3;
//   };

//   const dataTimeRange = getDataTimeRange();

//   return (
//     <div className="h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 p-3 overflow-hidden">
//       <div className="h-full flex flex-col">
//         <div className="mb-3 flex items-center justify-between">
//           <h1 className="text-2xl font-bold text-white flex items-center gap-2">
//             <BarChart3 className="h-6 w-6 text-cyan-400" />
//             Width Measurement History
//           </h1>
//           <div className="flex items-center gap-3">
//             <div className="flex items-center gap-2">
//               {isConnected ? <Wifi className="h-4 w-4 text-emerald-400" /> : <WifiOff className="h-4 w-4 text-red-400" />}
//               <span className={`text-xs ${isConnected ? 'text-emerald-400' : 'text-red-400'}`}>
//                 {isConnected ? 'Connected' : 'Offline'}
//               </span>
//             </div>
            
//             <span className="text-lg font-semibold text-white">{formatDate(selectedDate)}</span>
            
//             <select
//               value={selectedMaterial}
//               onChange={(e) => setSelectedMaterial(e.target.value)}
//               className="bg-slate-800 text-white px-2 py-1 rounded-lg text-sm border border-slate-700"
//             >
//               <option value="all">All Materials</option>
//               {availableMaterials.map(code => (
//                 <option key={code} value={code}>{code}</option>
//               ))}
//             </select>
            
//             <select
//               value={selectedTimeRange}
//               onChange={(e) => setSelectedTimeRange(e.target.value)}
//               className="bg-slate-800 text-white px-2 py-1 rounded-lg text-sm border border-slate-700"
//             >
//               <option value="all">All Day (24h)</option>
//               <option value="shift1">Shift 1 (06:00-14:00)</option>
//               <option value="shift2">Shift 2 (14:00-22:00)</option>
//               <option value="shift3">Shift 3 (22:00-06:00)</option>
//             </select>
            
//             <button onClick={fetchDailyData} className="p-1.5 bg-slate-800 hover:bg-slate-700 rounded-lg">
//               <RefreshCw className={`h-4 w-4 text-white ${loading ? 'animate-spin' : ''}`} />
//             </button>
//             <button onClick={downloadCSV} className="p-1.5 bg-slate-800 hover:bg-slate-700 rounded-lg" disabled={filteredData.length === 0}>
//               <Download className="h-4 w-4 text-white" />
//             </button>
//           </div>
//         </div>

//         {errorMessage && (
//           <div className="mb-3 p-3 bg-red-900/50 border border-red-700 rounded-lg text-red-200 text-sm">
//             <strong>Error:</strong> {errorMessage}
//           </div>
//         )}

//         <div className="flex-1 flex gap-3">
//           <div className="flex-1 flex flex-col gap-3">
//             <div className="bg-slate-900/80 backdrop-blur-xl rounded-xl border border-slate-800 p-4 flex-1">
//               <div className="mb-2 flex items-center justify-between">
//                 <h2 className="text-lg font-semibold text-white flex items-center gap-2">
//                   <Activity className="h-4 w-4 text-green-400" />
//                   Width Measurements
//                   <span className="text-sm font-normal text-slate-400">
//                     ({statistics?.totalMeasurements || 0} points
//                     {isAggregated && totalRawRecords > 0 && (
//                       <span className="text-yellow-400"> from {totalRawRecords.toLocaleString()} samples</span>
//                     )})
//                   </span>
//                   {isAggregated && (
//                     <span className="ml-2 px-2 py-0.5 bg-yellow-500/20 text-yellow-400 text-xs rounded-full flex items-center gap-1">
//                       <Layers className="h-3 w-3" />
//                       Aggregated
//                     </span>
//                   )}
//                 </h2>
                
//                 {filteredData.length > 0 && (
//                   <div className="flex items-center gap-2 px-3 py-1 bg-slate-800 rounded-lg">
//                     <Clock className="h-4 w-4 text-cyan-400" />
//                     <span className="text-sm text-white">
//                       Data: <span className="text-cyan-400">{dataTimeRange.start}</span> - <span className="text-cyan-400">{dataTimeRange.end}</span>
//                     </span>
//                   </div>
//                 )}
//               </div>

//               {loading ? (
//                 <div className="h-full flex items-center justify-center">
//                   <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-cyan-400" />
//                 </div>
//               ) : filteredData.length === 0 ? (
//                 <div className="h-full flex items-center justify-center flex-col gap-2">
//                   <p className="text-slate-400">No data available for selected filters</p>
//                   <p className="text-slate-500 text-sm">Try selecting a date with data (highlighted in cyan)</p>
//                 </div>
//               ) : (
//                 <div className="relative h-full">
//                   <svg ref={graphRef} width="100%" height="100%" viewBox={`0 0 ${graphWidth} ${graphHeight}`} preserveAspectRatio="xMidYMid meet">
//                     <g transform={`translate(${padding.left}, ${padding.top})`}>
//                       {/* Y-axis grid lines and labels */}
//                       {getYAxisLabels().map(value => {
//                         const y = yScale(value);
//                         const isSpecLimit = currentMaterialSpecs && (value === currentMaterialSpecs.min || value === currentMaterialSpecs.max);
//                         const isTarget = currentMaterialSpecs && value === currentMaterialSpecs.film_width;
                        
//                         return (
//                           <g key={value}>
//                             <line x1={0} y1={y} x2={chartWidth} y2={y}
//                               stroke={isSpecLimit ? "rgba(239, 68, 68, 0.3)" : isTarget ? "rgba(16, 185, 129, 0.3)" : "rgba(148, 163, 184, 0.1)"}
//                               strokeDasharray={isSpecLimit || isTarget ? "0" : "5,5"}
//                               strokeWidth={isSpecLimit || isTarget ? "1.5" : "1"}
//                             />
//                             <text x={-8} y={y + 3} fill={isSpecLimit ? "#ef4444" : isTarget ? "#10b981" : "#94a3b8"} fontSize="10" textAnchor="end">
//                               {value.toFixed(0)}
//                             </text>
//                           </g>
//                         );
//                       })}
                      
//                       {/* Spec range highlight */}
//                       {currentMaterialSpecs && (
//                         <rect x={0} y={yScale(currentMaterialSpecs.max)} width={chartWidth}
//                           height={yScale(currentMaterialSpecs.min) - yScale(currentMaterialSpecs.max)}
//                           fill="rgba(16, 185, 129, 0.05)" stroke="none"
//                         />
//                       )}
                      
//                       {/* Vertical grid lines for hours */}
//                       {generateTimeLabels().map((label, idx) => {
//                         const x = xScaleHour(label.hour);
//                         return (
//                           <line key={`vgrid-${idx}`} x1={x} y1={0} x2={x} y2={chartHeight}
//                             stroke="rgba(148, 163, 184, 0.1)" strokeDasharray="5,5" strokeWidth="1"
//                           />
//                         );
//                       })}
                      
//                       {/* Data line */}
//                       {filteredData.length > 1 && (
//                         <polyline fill="none" stroke="#06b6d4" strokeWidth={filteredData.length > 200 ? "1" : "1.5"} strokeOpacity="0.8"
//                           points={filteredData.map(d => `${xScale(d.timestamp)},${yScale(d.widthMM)}`).join(' ')}
//                         />
//                       )}
                      
//                       {/* Data points */}
//                       {filteredData.map((d, i) => {
//                         const radius = getDataPointRadius();
//                         return (
//                           <circle key={i} cx={xScale(d.timestamp)} cy={yScale(d.widthMM)}
//                             r={d.isDefect ? radius * 1.5 : radius}
//                             fill={d.isDefect ? "#ef4444" : "#06b6d4"}
//                             fillOpacity={d.isDefect ? 0.9 : 0.7}
//                             stroke={d.isDefect ? "#dc2626" : "#0891b2"}
//                             strokeWidth={1}
//                             style={{ cursor: 'pointer' }}
//                             onMouseEnter={() => setHoveredPoint({ ...d, index: i })}
//                             onMouseLeave={() => setHoveredPoint(null)}
//                           />
//                         );
//                       })}
                      
//                       {/* X-axis */}
//                       <line x1={0} y1={chartHeight} x2={chartWidth} y2={chartHeight} stroke="#475569" strokeWidth="2" />
                      
//                       {/* X-axis labels - FULL 24 hours */}
//                       {generateTimeLabels().map((label, idx) => {
//                         const x = xScaleHour(label.hour);
//                         return (
//                           <g key={idx}>
//                             <line x1={x} y1={chartHeight} x2={x} y2={chartHeight + 5} stroke="#475569" />
//                             <text x={x} y={chartHeight + 20} fill="#94a3b8" fontSize="10" textAnchor="middle">
//                               {label.label}
//                             </text>
//                           </g>
//                         );
//                       })}
                      
//                       {/* Y-axis */}
//                       <line x1={0} y1={0} x2={0} y2={chartHeight} stroke="#475569" strokeWidth="2" />
                      
//                       {/* Axis labels */}
//                       <text x={chartWidth / 2} y={chartHeight + 45} fill="#94a3b8" fontSize="12" textAnchor="middle" fontWeight="500">
//                         Time (24-Hour Format) - Full Day View
//                       </text>
//                       <text x={-chartHeight / 2} y={-40} fill="#94a3b8" fontSize="12" textAnchor="middle" transform="rotate(-90)" fontWeight="500">
//                         Width (mm)
//                       </text>
//                     </g>
//                   </svg>
                  
//                   {/* Tooltip */}
//                   {hoveredPoint && (
//                     <div className="absolute bg-slate-800 border border-slate-600 rounded-lg p-3 pointer-events-none z-10 shadow-xl"
//                       style={{ left: '50%', top: '20%', transform: 'translate(-50%, -50%)' }}>
//                       <p className="text-sm text-white font-semibold mb-1">{hoveredPoint.time}</p>
//                       <p className="text-sm text-cyan-400">Width: <span className="font-bold">{hoveredPoint.widthMM.toFixed(2)}mm</span></p>
//                       {hoveredPoint.sampleCount > 1 && <p className="text-xs text-yellow-400">Samples in bin: {hoveredPoint.sampleCount}</p>}
//                       <p className="text-xs text-purple-400 mt-1">Material: {hoveredPoint.material_code}</p>
//                       <p className="text-xs text-slate-400">{hoveredPoint.material_name}</p>
//                       {hoveredPoint.isDefect && (
//                         <p className="text-xs text-red-400 font-bold mt-1">⚠️ {hoveredPoint.defectType} ({hoveredPoint.deviation.toFixed(2)}mm)</p>
//                       )}
//                       <p className="text-xs text-slate-500 mt-1">Spec: {hoveredPoint.specs.min}-{hoveredPoint.specs.max}mm</p>
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>

//             {/* Stats cards */}
//             <div className="flex gap-3">
//               <div className="flex-1 bg-slate-900/80 backdrop-blur-xl rounded-lg border border-slate-800 p-3">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <p className="text-xs text-slate-400">Average Width</p>
//                     <p className="text-xl font-bold text-white">{statistics?.average || '--'}mm</p>
//                     <p className="text-xs text-slate-500">Range: {statistics?.min || '--'} - {statistics?.max || '--'}mm</p>
//                   </div>
//                   <Activity className="h-6 w-6 text-purple-400" />
//                 </div>
//               </div>
              
//               <div className="flex-1 bg-slate-900/80 backdrop-blur-xl rounded-lg border border-slate-800 p-3">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <p className="text-xs text-slate-400">Defects Found</p>
//                     <p className="text-xl font-bold text-red-400">{statistics?.defectCount || 0}</p>
//                     <p className="text-xs text-slate-500">↓{statistics?.underSpec || 0} under / ↑{statistics?.overSpec || 0} over</p>
//                   </div>
//                   <AlertTriangle className="h-6 w-6 text-red-400" />
//                 </div>
//               </div>
              
//               <div className="flex-1 bg-slate-900/80 backdrop-blur-xl rounded-lg border border-slate-800 p-3">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <p className="text-xs text-slate-400">Quality Rate</p>
//                     <p className="text-xl font-bold text-emerald-400">{statistics?.qualityRate || '100'}%</p>
//                     <p className="text-xs text-slate-500">{statistics?.goodCount || 0} / {statistics?.totalMeasurements || 0} good</p>
//                   </div>
//                   <BarChart3 className="h-6 w-6 text-cyan-400" />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right sidebar */}
//           <div className="w-72 flex flex-col gap-3">
//             {/* Calendar */}
//             <div className="bg-slate-900/80 backdrop-blur-xl rounded-xl border border-slate-800 p-3">
//               <div className="flex items-center justify-between mb-2">
//                 <button onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1))}
//                   className="p-0.5 hover:bg-slate-800 rounded-lg">
//                   <ChevronLeft className="h-4 w-4 text-white" />
//                 </button>
//                 <span className="text-sm font-medium text-white">
//                   {MONTHS[currentMonth.getMonth()].slice(0, 3)} {currentMonth.getFullYear()}
//                 </span>
//                 <button onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1))}
//                   className="p-0.5 hover:bg-slate-800 rounded-lg">
//                   <ChevronRight className="h-4 w-4 text-white" />
//                 </button>
//               </div>
              
//               <div className="grid grid-cols-7 gap-1 mb-1">
//                 {DAYS_OF_WEEK.map((day, index) => (
//                   <div key={`day-${index}`} className="text-center text-xs font-medium text-slate-400">{day}</div>
//                 ))}
//               </div>
              
//               <div className="grid grid-cols-7 gap-0.5">
//                 {getCalendarDays().map((day, idx) => (
//                   <div key={`cal-${idx}`} className="aspect-square">
//                     {day && (
//                       <button onClick={() => handleDateSelect(day.dateStr)}
//                         className={`w-full h-full flex items-center justify-center rounded text-xs font-medium transition-all
//                           ${day.hasData ? "text-cyan-400 hover:bg-cyan-900/50 font-bold" : "text-slate-600 hover:bg-slate-800/50"}
//                           ${day.isToday ? "ring-1 ring-emerald-500" : ""}
//                           ${day.dateStr === selectedDate ? "bg-cyan-500 text-white" : ""}`}>
//                         {day.date}
//                       </button>
//                     )}
//                   </div>
//                 ))}
//               </div>
              
//               <p className="text-xs text-slate-500 mt-2 text-center">
//                 <span className="text-cyan-400 font-bold">Cyan</span> = has data
//               </p>
//             </div>
            
//             {/* Material Analysis */}
//             <div className="bg-slate-900/80 backdrop-blur-xl rounded-xl border border-slate-800 p-3 flex-1">
//               <h3 className="text-sm font-semibold text-white mb-2 flex items-center gap-2">
//                 <Package className="h-4 w-4 text-cyan-400" />
//                 Material Analysis
//               </h3>
              
//               {statistics?.materialBreakdown?.length > 0 ? (
//                 <div className="space-y-2 max-h-48 overflow-y-auto">
//                   {statistics.materialBreakdown.map((mat) => (
//                     <div key={mat.code} className="border border-slate-700 rounded-lg p-2">
//                       <p className="text-xs font-medium text-cyan-400">{mat.code}</p>
//                       <p className="text-xs text-slate-500 truncate">{mat.name}</p>
//                       <div className="mt-1 grid grid-cols-2 gap-1 text-xs">
//                         <div><span className="text-slate-500">Points:</span> <span className="text-white">{mat.count}</span></div>
//                         <div><span className="text-slate-500">Avg:</span> <span className="text-white">{mat.average}mm</span></div>
//                         <div><span className="text-slate-500">Defects:</span> <span className={mat.defects > 0 ? 'text-red-400' : 'text-green-400'}>{mat.defects}</span></div>
//                         <div><span className="text-slate-500">Quality:</span> <span className={parseFloat(mat.qualityRate) >= 95 ? 'text-green-400' : 'text-yellow-400'}>{mat.qualityRate}%</span></div>
//                         {mat.totalSamples > mat.count && (
//                           <div className="col-span-2"><span className="text-slate-500">Samples:</span> <span className="text-yellow-400">{mat.totalSamples.toLocaleString()}</span></div>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <p className="text-xs text-slate-400">No material data</p>
//               )}
              
//               <div className="mt-3 pt-3 border-t border-slate-800">
//                 <div className="flex items-center gap-2 text-xs text-slate-400">
//                   <Clock className="h-3 w-3" />
//                   <span>Data: {dataTimeRange.start} - {dataTimeRange.end}</span>
//                 </div>
//                 {isAggregated && (
//                   <p className="text-xs text-yellow-500 mt-1 flex items-center gap-1">
//                     <Layers className="h-3 w-3" />
//                     5-minute aggregation
//                   </p>
//                 )}
//                 {lastUpdate && <p className="text-xs text-slate-500 mt-1">Updated: {lastUpdate.toLocaleTimeString()}</p>}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WidthHistoryView;
import React, { useState, useEffect, useRef } from "react";
import {
  ChevronLeft,
  ChevronRight,
  Activity,
  BarChart3,
  Download,
  RefreshCw,
  Wifi,
  WifiOff,
  Package,
  AlertTriangle,
  Clock,
  Layers,
  Calendar
} from "lucide-react";
import { MATERIAL_SPECIFICATIONS, getMaterialSpecs, getDefectType } from '../../Materialspecs';

const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const WidthHistoryView = () => {
  const today = new Date();
  
  const [currentMonth, setCurrentMonth] = useState(new Date(2025, 11, 1));
  const [selectedDate, setSelectedDate] = useState('2025-12-26');
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [statistics, setStatistics] = useState(null);
  const [availableDates, setAvailableDates] = useState(new Set(['2025-12-26']));
  const [hoveredPoint, setHoveredPoint] = useState(null);
  const [selectedTimeRange, setSelectedTimeRange] = useState('all');
  const [selectedMaterial, setSelectedMaterial] = useState('all');
  const [availableMaterials, setAvailableMaterials] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [isAggregated, setIsAggregated] = useState(false);
  const [totalRawRecords, setTotalRawRecords] = useState(0);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loadingDates, setLoadingDates] = useState(false);
  
  const graphRef = useRef(null);
  
  const API_BASE = "https://oyplm85fk3.execute-api.us-east-1.amazonaws.com/prod";

  // Fetch available dates on mount
  useEffect(() => {
    fetchAvailableDates();
  }, []);

  // Scan for dates when month changes
  useEffect(() => {
    scanMonthForDates(currentMonth);
  }, [currentMonth]);

  const fetchAvailableDates = async () => {
    setLoadingDates(true);
    try {
      const response = await fetch(`${API_BASE}/dates`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      
      const data = await response.json();
      
      if (data.success && data.dates) {
        const dates = new Set(data.dates.map(d => d.date));
        setAvailableDates(prev => new Set([...prev, ...dates]));
        
        if (data.materials) {
          setAvailableMaterials(data.materials.filter(m => m && m !== 'unknown'));
        }
        
        setIsConnected(true);
        setErrorMessage(null);
        
        if (dates.size > 0) {
          const sortedDates = Array.from(dates).sort();
          const mostRecent = sortedDates[sortedDates.length - 1];
          setSelectedDate(mostRecent);
          
          const recentDate = new Date(mostRecent + 'T00:00:00');
          setCurrentMonth(new Date(recentDate.getFullYear(), recentDate.getMonth(), 1));
        }
      }
    } catch (error) {
      console.error('Failed to fetch dates:', error);
      scanRecentDates();
    } finally {
      setLoadingDates(false);
    }
  };

  // Scan recent dates to find which ones have data
  const scanRecentDates = async () => {
    const datesToCheck = [];
    const now = new Date();
    
    for (let i = 0; i < 14; i++) {
      const date = new Date(now);
      date.setDate(date.getDate() - i);
      datesToCheck.push(date.toISOString().split('T')[0]);
    }
    
    for (const dateStr of datesToCheck) {
      checkDateHasData(dateStr);
    }
  };

  // Scan a specific month for dates with data
  const scanMonthForDates = async (month) => {
    const year = month.getFullYear();
    const monthNum = month.getMonth();
    const daysInMonth = new Date(year, monthNum + 1, 0).getDate();
    
    const datesToCheck = [];
    
    // Check all days in the month
    for (let day = 1; day <= daysInMonth; day++) {
      const dateStr = `${year}-${String(monthNum + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      if (!availableDates.has(dateStr)) {
        datesToCheck.push(dateStr);
      }
    }
    
    // Check dates in batches to avoid overwhelming the API
    for (const dateStr of datesToCheck) {
      checkDateHasData(dateStr);
      await new Promise(resolve => setTimeout(resolve, 100)); // Small delay between requests
    }
  };

  // Check if a specific date has data
  const checkDateHasData = async (dateStr) => {
    if (availableDates.has(dateStr)) return;
    
    try {
      const response = await fetch(`${API_BASE}/download?date=${dateStr}&bin_minutes=1440`, {
        method: 'GET'
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.data && data.data.length > 0) {
          setAvailableDates(prev => new Set([...prev, dateStr]));
        }
      }
    } catch (e) {
      // Ignore errors
    }
  };

  const downsampleData = (data, maxPoints = 1000) => {
    if (data.length <= maxPoints) return { data, downsampled: false };
    
    const step = Math.ceil(data.length / maxPoints);
    const downsampled = [];
    
    for (let i = 0; i < data.length; i += step) {
      const chunk = data.slice(i, Math.min(i + step, data.length));
      
      const avgWidth = chunk.reduce((sum, d) => sum + d.widthMM, 0) / chunk.length;
      const minWidth = Math.min(...chunk.map(d => d.widthMM));
      const maxWidth = Math.max(...chunk.map(d => d.widthMM));
      
      downsampled.push({
        ...chunk[0],
        widthMM: avgWidth,
        widthMinMM: minWidth,
        widthMaxMM: maxWidth,
        sampleCount: chunk.reduce((sum, d) => sum + (d.sampleCount || 1), 0),
        isAggregated: true
      });
    }
    
    return { data: downsampled, downsampled: true };
  };

  const fetchDailyData = async () => {
    if (!selectedDate) return;
    
    setLoading(true);
    setErrorMessage(null);
    
    try {
      const url = `${API_BASE}/download?date=${selectedDate}&bin_minutes=5`;
      console.log('Fetching:', url);
      
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      
      if (data.success && data.data && data.data.length > 0) {
        // Mark this date as having data
        setAvailableDates(prev => new Set([...prev, selectedDate]));
        
        let processedData = data.data.map(record => {
          const time = new Date(record.time || record.timestamp);
          const materialCode = record.sensor_type || 'unknown';
          const specs = getMaterialSpecs(materialCode);
          
          const widthInMeters = parseFloat(record.width_meters || 0);
          const widthInMM = widthInMeters * 1000;
          
          const widthMinMM = record.width_min ? parseFloat(record.width_min) * 1000 : widthInMM;
          const widthMaxMM = record.width_max ? parseFloat(record.width_max) * 1000 : widthInMM;
          
          const isDefect = widthInMM < specs.min || widthInMM > specs.max;
          const defectInfo = getDefectType(widthInMeters, materialCode);
          
          return {
            time: time.toLocaleTimeString('en-US', { 
              hour: '2-digit', 
              minute: '2-digit',
              hour12: false 
            }),
            timestamp: time,
            date: time.toISOString().split('T')[0],
            width: widthInMeters,
            widthMM: widthInMM,
            widthMinMM: widthMinMM,
            widthMaxMM: widthMaxMM,
            sampleCount: record.sample_count || 1,
            device_id: record.device_id || 'unknown',
            location: record.location || 'unknown',
            material_code: materialCode,
            material_name: specs.name,
            isDefect: isDefect,
            defectType: defectInfo?.type || null,
            deviation: defectInfo?.deviation || 0,
            specs: specs
          };
        });
        
        processedData.sort((a, b) => a.timestamp - b.timestamp);
        
        const { data: finalData, downsampled } = downsampleData(processedData, 1500);
        
        setAllData(finalData);
        setIsAggregated(data.aggregated || downsampled);
        setTotalRawRecords(data.total_records || processedData.reduce((sum, d) => sum + (d.sampleCount || 1), 0));
        setIsConnected(true);
        setLastUpdate(new Date());
        
        const materials = [...new Set(finalData.map(d => d.material_code).filter(m => m && m !== 'unknown'))];
        if (materials.length > 0) {
          setAvailableMaterials(prev => [...new Set([...prev, ...materials])]);
        }
        
        console.log(`Loaded ${finalData.length} data points for ${selectedDate}`);
      } else {
        setAllData([]);
        if (data.data && data.data.length === 0) {
          setErrorMessage('No data available for this date');
        } else {
          setErrorMessage(data.error || 'No data returned');
        }
      }
    } catch (error) {
      console.error('Failed to fetch daily data:', error);
      setIsConnected(false);
      setErrorMessage(error.message);
      setAllData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedDate) {
      fetchDailyData();
    }
  }, [selectedDate]);

  useEffect(() => {
    if (allData.length > 0) {
      let dayData = [...allData];
      
      if (selectedMaterial !== 'all') {
        dayData = dayData.filter(d => d.material_code === selectedMaterial);
      }
      
      if (selectedTimeRange !== 'all') {
        dayData = dayData.filter(d => {
          const hour = d.timestamp.getHours();
          if (selectedTimeRange === 'morning') return hour >= 6 && hour < 12;
          if (selectedTimeRange === 'afternoon') return hour >= 12 && hour < 18;
          if (selectedTimeRange === 'evening') return hour >= 18 || hour < 6;
          if (selectedTimeRange === 'shift1') return hour >= 6 && hour < 14;
          if (selectedTimeRange === 'shift2') return hour >= 14 && hour < 22;
          if (selectedTimeRange === 'shift3') return hour >= 22 || hour < 6;
          return true;
        });
      }
      
      dayData.sort((a, b) => a.timestamp - b.timestamp);
      
      setFilteredData(dayData);
      setStatistics(calculateStatistics(dayData));
    } else {
      setFilteredData([]);
      setStatistics(null);
    }
  }, [allData, selectedTimeRange, selectedMaterial]);

  const calculateStatistics = (data) => {
    if (!data || data.length === 0) return null;
    
    const widthsMM = data.map(d => d.widthMM);
    const defects = data.filter(d => d.isDefect);
    const underSpec = defects.filter(d => d.defectType === 'Under Spec');
    const overSpec = defects.filter(d => d.defectType === 'Over Spec');
    
    const totalSamples = data.reduce((sum, d) => sum + (d.sampleCount || 1), 0);
    
    const goodParts = data.length - defects.length;
    const qualityRate = data.length > 0 ? (goodParts / data.length * 100).toFixed(1) : 100;
    
    const materialBreakdown = {};
    data.forEach(d => {
      if (!materialBreakdown[d.material_code]) {
        materialBreakdown[d.material_code] = {
          code: d.material_code,
          name: d.material_name,
          specs: d.specs,
          measurements: [],
          defects: 0,
          totalSamples: 0
        };
      }
      materialBreakdown[d.material_code].measurements.push(d.widthMM);
      materialBreakdown[d.material_code].totalSamples += (d.sampleCount || 1);
      if (d.isDefect) materialBreakdown[d.material_code].defects++;
    });
    
    Object.values(materialBreakdown).forEach(mat => {
      const measurements = mat.measurements;
      mat.count = measurements.length;
      mat.average = (measurements.reduce((a, b) => a + b, 0) / measurements.length).toFixed(1);
      mat.qualityRate = ((mat.count - mat.defects) / mat.count * 100).toFixed(1);
    });
    
    return {
      average: (widthsMM.reduce((a, b) => a + b, 0) / widthsMM.length).toFixed(1),
      min: Math.min(...widthsMM).toFixed(1),
      max: Math.max(...widthsMM).toFixed(1),
      stdDev: calculateStdDev(widthsMM).toFixed(2),
      totalMeasurements: data.length,
      totalSamples: totalSamples,
      goodCount: goodParts,
      defectCount: defects.length,
      qualityRate: qualityRate,
      underSpec: underSpec.length,
      overSpec: overSpec.length,
      materialBreakdown: Object.values(materialBreakdown)
    };
  };

  const calculateStdDev = (values) => {
    if (values.length === 0) return 0;
    const mean = values.reduce((a, b) => a + b, 0) / values.length;
    const squaredDiffs = values.map(v => Math.pow(v - mean, 2));
    const avgSquaredDiff = squaredDiffs.reduce((a, b) => a + b, 0) / values.length;
    return Math.sqrt(avgSquaredDiff);
  };

  const generateTimeLabels = () => {
    const labels = [];
    for (let hour = 0; hour <= 24; hour += 2) {
      const h = hour.toString().padStart(2, '0');
      labels.push({ hour: hour, label: `${h}:00` });
    }
    return labels;
  };

  const getDataTimeRange = () => {
    if (filteredData.length === 0) return { start: 'No data', end: '' };
    
    const startTime = filteredData[0].timestamp;
    const endTime = filteredData[filteredData.length - 1].timestamp;
    
    return {
      start: startTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false }),
      end: endTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false })
    };
  };

  const getCalendarDays = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const days = [];
    
    const todayStr = today.toLocaleDateString('en-CA');

    for (let i = 0; i < firstDay; i++) days.push(null);

    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const dateStr = date.toLocaleDateString('en-CA');
      days.push({
        date: day,
        dateStr,
        hasData: availableDates.has(dateStr),
        isToday: dateStr === todayStr,
      });
    }

    return days;
  };

  const handleDateSelect = (dateStr) => {
    if (!dateStr) return;
    setSelectedDate(dateStr);
    checkDateHasData(dateStr);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr + 'T00:00:00');
    return `${MONTHS[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  };

  const downloadCSV = () => {
    if (filteredData.length === 0) return;
    
    const headers = ['Time', 'Width (mm)', 'Samples', 'Material Code', 'Status', 'Device'];
    const rows = filteredData.map(d => [
      d.timestamp.toISOString(),
      d.widthMM.toFixed(1),
      d.sampleCount,
      d.material_code,
      d.isDefect ? d.defectType : 'Normal',
      d.device_id
    ]);
    
    const csvContent = [headers.join(','), ...rows.map(row => row.join(','))].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `width_data_${selectedDate}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const refreshDates = () => {
    setAvailableDates(new Set());
    fetchAvailableDates();
    scanMonthForDates(currentMonth);
  };

  const currentMaterialSpecs = selectedMaterial !== 'all' ? getMaterialSpecs(selectedMaterial) : null;

  const graphWidth = 900;
  const graphHeight = 350;
  const padding = { top: 30, right: 20, bottom: 60, left: 60 };
  const chartWidth = graphWidth - padding.left - padding.right;
  const chartHeight = graphHeight - padding.top - padding.bottom;

  const xScale = (timestamp) => {
    const hours = timestamp.getHours() + timestamp.getMinutes() / 60 + timestamp.getSeconds() / 3600;
    return (hours / 24) * chartWidth;
  };

  const xScaleHour = (hour) => {
    return (hour / 24) * chartWidth;
  };
  
  const yScale = (widthMM) => {
    let minRange = 500, maxRange = 600;
    
    if (currentMaterialSpecs) {
      minRange = currentMaterialSpecs.min - 10;
      maxRange = currentMaterialSpecs.max + 10;
    } else if (filteredData.length > 0) {
      const widths = filteredData.map(d => d.widthMM);
      minRange = Math.min(...widths) - 5;
      maxRange = Math.max(...widths) + 5;
    }
    
    return chartHeight - ((widthMM - minRange) / (maxRange - minRange)) * chartHeight;
  };

  const getYAxisLabels = () => {
    const labels = [];
    let minRange = 500, maxRange = 600;
    
    if (currentMaterialSpecs) {
      minRange = currentMaterialSpecs.min - 10;
      maxRange = currentMaterialSpecs.max + 10;
    } else if (filteredData.length > 0) {
      const widths = filteredData.map(d => d.widthMM);
      minRange = Math.min(...widths) - 5;
      maxRange = Math.max(...widths) + 5;
    }
    
    const step = (maxRange - minRange) / 10;
    for (let i = 0; i <= 10; i++) labels.push(minRange + (step * i));
    
    if (currentMaterialSpecs) {
      labels.push(currentMaterialSpecs.min, currentMaterialSpecs.max, currentMaterialSpecs.film_width);
    }
    
    return [...new Set(labels)].sort((a, b) => a - b);
  };

  const getDataPointRadius = () => {
    const pointCount = filteredData.length;
    if (pointCount > 500) return 1.5;
    if (pointCount > 200) return 2;
    if (pointCount > 100) return 2.5;
    return 3;
  };

  const dataTimeRange = getDataTimeRange();

  return (
    <div className="h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 p-3 overflow-hidden">
      <div className="h-full flex flex-col">
        <div className="mb-3 flex items-center justify-between">
          <h1 className="text-2xl font-bold text-white flex items-center gap-2">
            <BarChart3 className="h-6 w-6 text-cyan-400" />
            Width Measurement History
          </h1>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              {isConnected ? <Wifi className="h-4 w-4 text-emerald-400" /> : <WifiOff className="h-4 w-4 text-red-400" />}
              <span className={`text-xs ${isConnected ? 'text-emerald-400' : 'text-red-400'}`}>
                {isConnected ? 'Connected' : 'Offline'}
              </span>
            </div>
            
            <span className="text-lg font-semibold text-white">{formatDate(selectedDate)}</span>
            
            <select
              value={selectedMaterial}
              onChange={(e) => setSelectedMaterial(e.target.value)}
              className="bg-slate-800 text-white px-2 py-1 rounded-lg text-sm border border-slate-700"
            >
              <option value="all">All Materials</option>
              {availableMaterials.map(code => (
                <option key={code} value={code}>{code}</option>
              ))}
            </select>
            
            <select
              value={selectedTimeRange}
              onChange={(e) => setSelectedTimeRange(e.target.value)}
              className="bg-slate-800 text-white px-2 py-1 rounded-lg text-sm border border-slate-700"
            >
              <option value="all">All Day (24h)</option>
              <option value="shift1">Shift 1 (06:00-14:00)</option>
              <option value="shift2">Shift 2 (14:00-22:00)</option>
              <option value="shift3">Shift 3 (22:00-06:00)</option>
            </select>
            
            <button onClick={fetchDailyData} className="p-1.5 bg-slate-800 hover:bg-slate-700 rounded-lg">
              <RefreshCw className={`h-4 w-4 text-white ${loading ? 'animate-spin' : ''}`} />
            </button>
            <button onClick={downloadCSV} className="p-1.5 bg-slate-800 hover:bg-slate-700 rounded-lg" disabled={filteredData.length === 0}>
              <Download className="h-4 w-4 text-white" />
            </button>
          </div>
        </div>

        {errorMessage && (
          <div className="mb-3 p-3 bg-red-900/50 border border-red-700 rounded-lg text-red-200 text-sm">
            <strong>Error:</strong> {errorMessage}
          </div>
        )}

        <div className="flex-1 flex gap-3">
          <div className="flex-1 flex flex-col gap-3">
            <div className="bg-slate-900/80 backdrop-blur-xl rounded-xl border border-slate-800 p-4 flex-1">
              <div className="mb-2 flex items-center justify-between">
                <h2 className="text-lg font-semibold text-white flex items-center gap-2">
                  <Activity className="h-4 w-4 text-green-400" />
                  Width Measurements
                  <span className="text-sm font-normal text-slate-400">
                    ({statistics?.totalMeasurements || 0} points
                    {isAggregated && totalRawRecords > 0 && (
                      <span className="text-yellow-400"> from {totalRawRecords.toLocaleString()} samples</span>
                    )})
                  </span>
                  {isAggregated && (
                    <span className="ml-2 px-2 py-0.5 bg-yellow-500/20 text-yellow-400 text-xs rounded-full flex items-center gap-1">
                      <Layers className="h-3 w-3" />
                      Aggregated
                    </span>
                  )}
                </h2>
                
                {filteredData.length > 0 && (
                  <div className="flex items-center gap-2 px-3 py-1 bg-slate-800 rounded-lg">
                    <Clock className="h-4 w-4 text-cyan-400" />
                    <span className="text-sm text-white">
                      Data: <span className="text-cyan-400">{dataTimeRange.start}</span> - <span className="text-cyan-400">{dataTimeRange.end}</span>
                    </span>
                  </div>
                )}
              </div>

              {loading ? (
                <div className="h-full flex items-center justify-center">
                  <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-cyan-400" />
                </div>
              ) : filteredData.length === 0 ? (
                <div className="h-full flex items-center justify-center flex-col gap-2">
                  <p className="text-slate-400">No data available for selected filters</p>
                  <p className="text-slate-500 text-sm">Try selecting a date with data (highlighted in cyan)</p>
                </div>
              ) : (
                <div className="relative h-full">
                  <svg ref={graphRef} width="100%" height="100%" viewBox={`0 0 ${graphWidth} ${graphHeight}`} preserveAspectRatio="xMidYMid meet">
                    <g transform={`translate(${padding.left}, ${padding.top})`}>
                      {getYAxisLabels().map(value => {
                        const y = yScale(value);
                        const isSpecLimit = currentMaterialSpecs && (value === currentMaterialSpecs.min || value === currentMaterialSpecs.max);
                        const isTarget = currentMaterialSpecs && value === currentMaterialSpecs.film_width;
                        
                        return (
                          <g key={value}>
                            <line x1={0} y1={y} x2={chartWidth} y2={y}
                              stroke={isSpecLimit ? "rgba(239, 68, 68, 0.3)" : isTarget ? "rgba(16, 185, 129, 0.3)" : "rgba(148, 163, 184, 0.1)"}
                              strokeDasharray={isSpecLimit || isTarget ? "0" : "5,5"}
                              strokeWidth={isSpecLimit || isTarget ? "1.5" : "1"}
                            />
                            <text x={-8} y={y + 3} fill={isSpecLimit ? "#ef4444" : isTarget ? "#10b981" : "#94a3b8"} fontSize="10" textAnchor="end">
                              {value.toFixed(0)}
                            </text>
                          </g>
                        );
                      })}
                      
                      {currentMaterialSpecs && (
                        <rect x={0} y={yScale(currentMaterialSpecs.max)} width={chartWidth}
                          height={yScale(currentMaterialSpecs.min) - yScale(currentMaterialSpecs.max)}
                          fill="rgba(16, 185, 129, 0.05)" stroke="none"
                        />
                      )}
                      
                      {generateTimeLabels().map((label, idx) => {
                        const x = xScaleHour(label.hour);
                        return (
                          <line key={`vgrid-${idx}`} x1={x} y1={0} x2={x} y2={chartHeight}
                            stroke="rgba(148, 163, 184, 0.1)" strokeDasharray="5,5" strokeWidth="1"
                          />
                        );
                      })}
                      
                      {filteredData.length > 1 && (
                        <polyline fill="none" stroke="#06b6d4" strokeWidth={filteredData.length > 200 ? "1" : "1.5"} strokeOpacity="0.8"
                          points={filteredData.map(d => `${xScale(d.timestamp)},${yScale(d.widthMM)}`).join(' ')}
                        />
                      )}
                      
                      {filteredData.map((d, i) => {
                        const radius = getDataPointRadius();
                        return (
                          <circle key={i} cx={xScale(d.timestamp)} cy={yScale(d.widthMM)}
                            r={d.isDefect ? radius * 1.5 : radius}
                            fill={d.isDefect ? "#ef4444" : "#06b6d4"}
                            fillOpacity={d.isDefect ? 0.9 : 0.7}
                            stroke={d.isDefect ? "#dc2626" : "#0891b2"}
                            strokeWidth={1}
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={() => setHoveredPoint({ ...d, index: i })}
                            onMouseLeave={() => setHoveredPoint(null)}
                          />
                        );
                      })}
                      
                      <line x1={0} y1={chartHeight} x2={chartWidth} y2={chartHeight} stroke="#475569" strokeWidth="2" />
                      
                      {generateTimeLabels().map((label, idx) => {
                        const x = xScaleHour(label.hour);
                        return (
                          <g key={idx}>
                            <line x1={x} y1={chartHeight} x2={x} y2={chartHeight + 5} stroke="#475569" />
                            <text x={x} y={chartHeight + 20} fill="#94a3b8" fontSize="10" textAnchor="middle">
                              {label.label}
                            </text>
                          </g>
                        );
                      })}
                      
                      <line x1={0} y1={0} x2={0} y2={chartHeight} stroke="#475569" strokeWidth="2" />
                      
                      <text x={chartWidth / 2} y={chartHeight + 45} fill="#94a3b8" fontSize="12" textAnchor="middle" fontWeight="500">
                        Time (24-Hour Format) - Full Day View
                      </text>
                      <text x={-chartHeight / 2} y={-40} fill="#94a3b8" fontSize="12" textAnchor="middle" transform="rotate(-90)" fontWeight="500">
                        Width (mm)
                      </text>
                    </g>
                  </svg>
                  
                  {hoveredPoint && (
                    <div className="absolute bg-slate-800 border border-slate-600 rounded-lg p-3 pointer-events-none z-10 shadow-xl"
                      style={{ left: '50%', top: '20%', transform: 'translate(-50%, -50%)' }}>
                      <p className="text-sm text-white font-semibold mb-1">{hoveredPoint.time}</p>
                      <p className="text-sm text-cyan-400">Width: <span className="font-bold">{hoveredPoint.widthMM.toFixed(2)}mm</span></p>
                      {hoveredPoint.sampleCount > 1 && <p className="text-xs text-yellow-400">Samples in bin: {hoveredPoint.sampleCount}</p>}
                      <p className="text-xs text-purple-400 mt-1">Material: {hoveredPoint.material_code}</p>
                      <p className="text-xs text-slate-400">{hoveredPoint.material_name}</p>
                      {hoveredPoint.isDefect && (
                        <p className="text-xs text-red-400 font-bold mt-1">⚠️ {hoveredPoint.defectType} ({hoveredPoint.deviation.toFixed(2)}mm)</p>
                      )}
                      <p className="text-xs text-slate-500 mt-1">Spec: {hoveredPoint.specs.min}-{hoveredPoint.specs.max}mm</p>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="flex gap-3">
              <div className="flex-1 bg-slate-900/80 backdrop-blur-xl rounded-lg border border-slate-800 p-3">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs text-slate-400">Average Width</p>
                    <p className="text-xl font-bold text-white">{statistics?.average || '--'}mm</p>
                    <p className="text-xs text-slate-500">Range: {statistics?.min || '--'} - {statistics?.max || '--'}mm</p>
                  </div>
                  <Activity className="h-6 w-6 text-purple-400" />
                </div>
              </div>
              
              <div className="flex-1 bg-slate-900/80 backdrop-blur-xl rounded-lg border border-slate-800 p-3">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs text-slate-400">Defects Found</p>
                    <p className="text-xl font-bold text-red-400">{statistics?.defectCount || 0}</p>
                    <p className="text-xs text-slate-500">↓{statistics?.underSpec || 0} under / ↑{statistics?.overSpec || 0} over</p>
                  </div>
                  <AlertTriangle className="h-6 w-6 text-red-400" />
                </div>
              </div>
              
              <div className="flex-1 bg-slate-900/80 backdrop-blur-xl rounded-lg border border-slate-800 p-3">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs text-slate-400">Quality Rate</p>
                    <p className="text-xl font-bold text-emerald-400">{statistics?.qualityRate || '100'}%</p>
                    <p className="text-xs text-slate-500">{statistics?.goodCount || 0} / {statistics?.totalMeasurements || 0} good</p>
                  </div>
                  <BarChart3 className="h-6 w-6 text-cyan-400" />
                </div>
              </div>
            </div>
          </div>

          <div className="w-72 flex flex-col gap-3">
            <div className="bg-slate-900/80 backdrop-blur-xl rounded-xl border border-slate-800 p-3">
              <div className="flex items-center justify-between mb-2">
                <button onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1))}
                  className="p-0.5 hover:bg-slate-800 rounded-lg">
                  <ChevronLeft className="h-4 w-4 text-white" />
                </button>
                <div className="flex items-center gap-2">
                  <Calendar className="h-4 w-4 text-cyan-400" />
                  <span className="text-sm font-medium text-white">
                    {MONTHS[currentMonth.getMonth()].slice(0, 3)} {currentMonth.getFullYear()}
                  </span>
                </div>
                <button onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1))}
                  className="p-0.5 hover:bg-slate-800 rounded-lg">
                  <ChevronRight className="h-4 w-4 text-white" />
                </button>
              </div>
              
              <div className="grid grid-cols-7 gap-1 mb-1">
                {DAYS_OF_WEEK.map((day, index) => (
                  <div key={`day-${index}`} className="text-center text-xs font-medium text-slate-400">{day}</div>
                ))}
              </div>
              
              <div className="grid grid-cols-7 gap-0.5">
                {getCalendarDays().map((day, idx) => (
                  <div key={`cal-${idx}`} className="aspect-square">
                    {day && (
                      <button onClick={() => handleDateSelect(day.dateStr)}
                        className={`w-full h-full flex items-center justify-center rounded text-xs font-medium transition-all
                          ${day.hasData ? "text-cyan-400 hover:bg-cyan-900/50 font-bold" : "text-slate-600 hover:bg-slate-800/50"}
                          ${day.isToday ? "ring-1 ring-emerald-500" : ""}
                          ${day.dateStr === selectedDate ? "bg-cyan-500 text-white" : ""}`}>
                        {day.date}
                      </button>
                    )}
                  </div>
                ))}
              </div>
              
              <div className="mt-2 flex items-center justify-between">
                <p className="text-xs text-slate-500">
                  <span className="text-cyan-400 font-bold">Cyan</span> = has data
                </p>
                <button 
                  onClick={refreshDates}
                  className="text-xs text-cyan-400 hover:text-cyan-300 flex items-center gap-1"
                  title="Scan all dates in month"
                >
                  <RefreshCw className={`h-3 w-3 ${loadingDates ? 'animate-spin' : ''}`} />
                  Scan
                </button>
              </div>
              
              <p className="text-xs text-slate-600 mt-1">
                {availableDates.size} dates found with data
              </p>
            </div>
            
            <div className="bg-slate-900/80 backdrop-blur-xl rounded-xl border border-slate-800 p-3 flex-1">
              <h3 className="text-sm font-semibold text-white mb-2 flex items-center gap-2">
                <Package className="h-4 w-4 text-cyan-400" />
                Material Analysis
              </h3>
              
              {statistics?.materialBreakdown?.length > 0 ? (
                <div className="space-y-2 max-h-48 overflow-y-auto">
                  {statistics.materialBreakdown.map((mat) => (
                    <div key={mat.code} className="border border-slate-700 rounded-lg p-2">
                      <p className="text-xs font-medium text-cyan-400">{mat.code}</p>
                      <p className="text-xs text-slate-500 truncate">{mat.name}</p>
                      <div className="mt-1 grid grid-cols-2 gap-1 text-xs">
                        <div><span className="text-slate-500">Points:</span> <span className="text-white">{mat.count}</span></div>
                        <div><span className="text-slate-500">Avg:</span> <span className="text-white">{mat.average}mm</span></div>
                        <div><span className="text-slate-500">Defects:</span> <span className={mat.defects > 0 ? 'text-red-400' : 'text-green-400'}>{mat.defects}</span></div>
                        <div><span className="text-slate-500">Quality:</span> <span className={parseFloat(mat.qualityRate) >= 95 ? 'text-green-400' : 'text-yellow-400'}>{mat.qualityRate}%</span></div>
                        {mat.totalSamples > mat.count && (
                          <div className="col-span-2"><span className="text-slate-500">Samples:</span> <span className="text-yellow-400">{mat.totalSamples.toLocaleString()}</span></div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-xs text-slate-400">No material data</p>
              )}
              
              <div className="mt-3 pt-3 border-t border-slate-800">
                <div className="flex items-center gap-2 text-xs text-slate-400">
                  <Clock className="h-3 w-3" />
                  <span>Data: {dataTimeRange.start} - {dataTimeRange.end}</span>
                </div>
                {isAggregated && (
                  <p className="text-xs text-yellow-500 mt-1 flex items-center gap-1">
                    <Layers className="h-3 w-3" />
                    5-minute aggregation
                  </p>
                )}
                {lastUpdate && <p className="text-xs text-slate-500 mt-1">Updated: {lastUpdate.toLocaleTimeString()}</p>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WidthHistoryView;